import { Component, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, map, Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { isEqual } from 'lodash';

@Component({
    selector: 'app-transaction-history-searchbar',
    styles: [`
    :host {
      display: block;
      height: 83px;
    }
  `],
    template: `
    <div class="pt-4 ps-3 pe-3">
      <div class="input-group mb-3">
        <span class="input-group-text bg-white">
          <span class="material-icons fs-5 fw-bold text-primary bg-white">search</span>
        </span>
        <input type="search"
               class="form-control bg-white border-start-0"
               placeholder="Belegnummer eingeben"
               i18n-placeholder
               [formControl]="searchControl"
               appAutofocus
        >
      </div>
    </div>
  `,
    standalone: false
})
export class HistorySearchbarComponent {
  @Output() searchChange: Observable<string | null>;

  searchControl = new UntypedFormControl('');

  constructor() {
    this.searchChange = this.searchControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(isEqual),
      map(value => !value ? null : value)
    );
  }
}
